import {inject, Injectable} from '@angular/core';
import {ServiceCase} from '../models/service-case';
import {ServiceCaseService} from './service-case.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceCaseLoader {
  private readonly serviceCaseService: ServiceCaseService = inject(ServiceCaseService);

  createServiceCase(serviceCase: ServiceCase): Promise<ServiceCase> {
    return this.serviceCaseService.createServiceCase(serviceCase);
  }

  getServiceCaseById(externalId: string): Promise<ServiceCase> {
    return this.serviceCaseService.getServiceCase(externalId);
  }

  getServiceCasesByVin(vin: string): Promise<ServiceCase[]> {
    return this.serviceCaseService.getServiceCasesByVin(vin);
  }
}
